import React from 'react'
import { SecurityServices } from '@carbon/icons-react';
import Swal from 'sweetalert2';
import { ApiDelete } from '../../../utils/apiServices';
import { useQuery } from '@tanstack/react-query';
import { ApiGet } from '../../../utils/apiServices';

const RoleManagement = ({RolesData , refetch}) => {
       



        const HandleUserDelete = async (id) => {
            
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'black',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
                preConfirm: async () => {
                    try {
                        Swal.showLoading();
                        const res = await ApiDelete("roles/" + id);
                        console.log(res, 'res')
                        if (res.status === "success") {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: res.message,
                            })
                            refetch();
                            return true;
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: res.data.message,
                            })
                            return false;
                        }
                    } catch (err) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: err.response.data.message || "Request failed",
                        })
                        return false;
                    }
                },
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading()
              })
            
                
        }

        const HandleUserEdit = async (id) => {
            // Edit role functionality

            const result = await ApiGet("roles/" + id);
            const {modules , name} = result;

            console.log(modules , name , "result");


            Swal.fire({
                title: 'Edit Role',
                text: "Edit role with ID: " + id,
                icon: 'info',
                html: `
                <input type="text" id="roleName" value="${name}" className="uk-input uk-margin-small-bottom">
                <div className="uk-margin-small-bottom">
                    <label for="modules">Modules:</label>
                    <select id="modules" className="uk-select uk-margin-small-bottom" multiple>
                        ${modules.map(module => `<option value="${module}">${module}</option>`).join('')}
                    </select>
                </div>
                `,
                showCancelButton: true,
                confirmButtonColor: 'black',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Save Changes'
            })
        }
  return (
                    <div className='uk-card uk-card-default uk-card-body'>
                           <div className="uk-padding">
                            <h2>Role Management
                            </h2>

                            <p>View and manage existing roles and their permissions

                            </p>

                            <div className="uk-margin-top">
                                {/* Header */}
                                <div className="uk-grid uk-grid-medium uk-flex-middle" uk-grid>
                                    <div className="uk-width-expand">
                                        <h4 className="uk-text-bold uk-margin-remove">Role</h4>
                                    </div>
                                    <div className="uk-width-1-2@m">
                                        <h4 className="uk-text-bold uk-margin-remove">Permissions</h4>
                                    </div>
                                </div>
                                <hr className="uk-margin-small" />

                                {/* Role List */}
                                <div className="uk-panel">
                                    {RolesData?.map((item, index) => (
                                        <div key={index} className="uk-grid uk-grid-medium uk-flex-middle uk-padding-small" uk-grid style={{borderBottom: '1px solid #e5e5e5'}}>
                                            {/* Left: Role Name */}
                                            <div className="uk-width-expand">
                                                <div className="uk-flex uk-flex-middle">

                                                    <SecurityServices size={44} className="uk-margin-right" />

                                                    <div className="uk-text-center">
                                                    <span className="uk-text-lead">{item.name}</span>
                                                    
                                                    <h6 className="">{item.permissionCount} Permissions </h6>
                                                    
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right: Permissions */}
                                            <div className="uk-width-1-2@m">
                                                <div className="module-permission-table-card">
                                                    <table className="module-permission-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Module</th>
                                                                <th>Permissions</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.permissionList.map((p, pIndex) => (
                                                                <tr key={pIndex}>
                                                                    <td className="module-permission-table-module">{p.name}</td>
                                                                    <td>
                                                                        <div className="module-permission-table-list">
                                                                            {p.permission.map((perm, idx) => (
                                                                                <span key={idx} className="module-permission-table-chip">{perm}</span>
                                                                            ))}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>


                                            {/* Edit Button */}
                                            {/* <div className="uk-margin-top">
                                                <button className="editbutton" onClick={() => HandleUserEdit(item.id)}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        className="svgIcon edit-icon"
                                                        stroke="black"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                                    </svg>
                                                </button>                                            
                                            </div> */}




                                            {/* Delete Button */}
                                            <div className="uk-margin-top">



                                                <button className="delbutton" onClick={() => HandleUserDelete(item.id)}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 69 14"
                                                        className="svgIcon bin-top"
                                                    >
                                                        <g clip-path="url(#clip0_35_24)">
                                                            <path
                                                                fill="black"
                                                                d="M20.8232 2.62734L19.9948 4.21304C19.8224 4.54309 19.4808 4.75 19.1085 4.75H4.92857C2.20246 4.75 0 6.87266 0 9.5C0 12.1273 2.20246 14.25 4.92857 14.25H64.0714C66.7975 14.25 69 12.1273 69 9.5C69 6.87266 66.7975 4.75 64.0714 4.75H49.8915C49.5192 4.75 49.1776 4.54309 49.0052 4.21305L48.1768 2.62734C47.3451 1.00938 45.6355 0 43.7719 0H25.2281C23.3645 0 21.6549 1.00938 20.8232 2.62734ZM64.0023 20.0648C64.0397 19.4882 63.5822 19 63.0044 19H5.99556C5.4178 19 4.96025 19.4882 4.99766 20.0648L8.19375 69.3203C8.44018 73.0758 11.6746 76 15.5712 76H53.4288C57.3254 76 60.5598 73.0758 60.8062 69.3203L64.0023 20.0648Z"
                                                            ></path>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_35_24">
                                                                <rect fill="white" height="14" width="69"></rect>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 69 57"
                                                        className="svgIcon bin-bottom"
                                                    >
                                                        <g clip-path="url(#clip0_35_22)">
                                                            <path
                                                                fill="black"
                                                                d="M20.8232 -16.3727L19.9948 -14.787C19.8224 -14.4569 19.4808 -14.25 19.1085 -14.25H4.92857C2.20246 -14.25 0 -12.1273 0 -9.5C0 -6.8727 2.20246 -4.75 4.92857 -4.75H64.0714C66.7975 -4.75 69 -6.8727 69 -9.5C69 -12.1273 66.7975 -14.25 64.0714 -14.25H49.8915C49.5192 -14.25 49.1776 -14.4569 49.0052 -14.787L48.1768 -16.3727C47.3451 -17.9906 45.6355 -19 43.7719 -19H25.2281C23.3645 -19 21.6549 -17.9906 20.8232 -16.3727ZM64.0023 1.0648C64.0397 0.4882 63.5822 0 63.0044 0H5.99556C5.4178 0 4.96025 0.4882 4.99766 1.0648L8.19375 50.3203C8.44018 54.0758 11.6746 57 15.5712 57H53.4288C57.3254 57 60.5598 54.0758 60.8062 50.3203L64.0023 1.0648Z"
                                                            ></path>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_35_22">
                                                                <rect fill="white" height="57" width="69"></rect>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </button>                                            
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>  
                        </div> 
  )
}

export default RoleManagement